import { render, staticRenderFns } from "./leaveSetup.vue?vue&type=template&id=d05cb696&scoped=true"
import script from "./leaveSetup.vue?vue&type=script&lang=js"
export * from "./leaveSetup.vue?vue&type=script&lang=js"
import style0 from "./leaveSetup.vue?vue&type=style&index=0&id=d05cb696&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d05cb696",
  null
  
)

export default component.exports